import React from "react"
import DateFnsUtils from "@date-io/date-fns"
import { ptBR } from "date-fns/locale"
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers"
import { Grid, InputLabel } from "@material-ui/core"

type SnoozePreviewProps = {
	fullTime: Date
	onFullTimeChange: (fullTime: Date) => void
}

const SnoozePreview: React.FC<SnoozePreviewProps> = ({
	fullTime,
	onFullTimeChange
}) => {
	return (
		<Grid item xs={12}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<InputLabel>Soneca será definida para:</InputLabel>
				</Grid>
				<Grid item xs={12}>
					<MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
						<DateTimePicker
							ampm={false}
							format="dd/MM/yyyy HH:mm"
							animateYearScrolling
							views={["year", "month", "date", "hours", "minutes"]}
							variant="inline"
							value={fullTime}
							inputVariant="outlined"
							fullWidth
							onChange={(date) => onFullTimeChange(date || new Date())}
							autoOk
							minDate={new Date()}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SnoozePreview
